export default "__VITE_ASSET__Cg3FA4_S__";